module.exports = __webpack_public_path__ + "img/ets-bill-tracker-nav-big.716bef00.png";